import DeleteIcon from "@mui/icons-material/Delete";
import {Button, Grid, IconButton, TextField, useMediaQuery} from "@mui/material";

import React from "react";
import {Controller, useFormContext} from "react-hook-form";
import MWCaption from "../../../components/MWCaption";
import {useConvertBase64} from "../../../hooks/useConvertBase64";

import {EQDepartment} from "../../../models/serverModels/EQDepartment";
import {
  FormContents,
  FormSection,
  InputFileContainer,
} from "../../../styledComponents/StyledCreateForm";

import MWSelectBox from "../../../components/MWSelectBox";
import MWTextField from "../../../components/MWTextField";

import FaceIcon from "@mui/icons-material/Face";
import PostAddIcon from "@mui/icons-material/PostAdd";
import {useRecoilValue} from "recoil";
import {tokenSelector} from "../../../Recoil/Atom/authState";
import MWInputFile from "../../../components/MWInputFile";
import {useDepartmentList} from "../../../hooks/useDepartmentList";

type SubTitleColorProps = {
  captionColor?: string;
};

const TutorForm = ({captionColor}: SubTitleColorProps) => {
  const tokenState = useRecoilValue(tokenSelector);

  //note  base64 custom hook
  const {convertChangeHandler, image} = useConvertBase64();

  const {departmentList} = useDepartmentList();

  const isMobile = useMediaQuery("(max-width: 780px)");

  //note 리액트 훅 폼
  const methods = useFormContext();

  const {
    setValue,
    getValues,
    reset,
    control,
    formState: {errors},
  } = methods;

  //note react-query - 부서리스트

  return (
    <React.Fragment>
      <FormSection>
        <MWCaption title={"강사관리"} color={captionColor} icon={<FaceIcon />} />
        <FormContents container rowSpacing={2}>
          <Grid container item xs={12} sm={12} lg={6}>
            <MWSelectBox<EQDepartment>
              name="departmentUID"
              label="부서명"
              data={departmentList?.items!}
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="name" label="강사명" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="carreer" label="경력사항" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="qualification" label="자격현황" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="internalEducation" label="내부교육이수현황" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="externalEducation1" label="외부교육이수현황1" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="externalEducation2" label="외부교육이수현황2" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="note" label="비고" />
          </Grid>
        </FormContents>
      </FormSection>
      <FormSection>
        <MWCaption title={"첨부파일"} color={captionColor} icon={<PostAddIcon />} />
        <InputFileContainer container rowSpacing={2}>
          {isMobile ? (
            <MWInputFile file="base64" fileName="certificationFile" buttonLabel="수료증등록" />
          ) : (
            <Grid item container sm={12} lg={12}>
              <Controller
                name="base64"
                control={control}
                render={({field: {onChange, name}}) => (
                  <Grid container alignItems="center" justifyContent="flex-start">
                    <Grid item xs={0} sm={3} md={2} sx={{display: {xs: "none", sm: "block"}}}>
                      <label style={{cursor: "pointer"}} htmlFor="base64">
                        수료증또는 자격증 등록 :
                      </label>
                    </Grid>
                    <Grid item xs={5} sm={3} md={1}>
                      <Button variant="contained" component="label" sx={{whiteSpace: "nowrap"}}>
                        파일 업로드
                        <TextField
                          sx={{display: "none"}}
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                            convertChangeHandler(event, setValue, name, "certificationFile")
                          }
                          type="file"
                          id="base64"
                          size="small"
                          hidden
                        />
                      </Button>
                    </Grid>
                    <Grid item xs={6} sm={5} md={8} alignItems="center">
                      <p>{getValues("certificationFile")}</p>
                    </Grid>
                    <Grid item xs={1} sm={1} md={1}>
                      <IconButton
                        style={
                          getValues("certificationFile") === null
                            ? {display: "none"}
                            : {display: "block"}
                        }
                        aria-label="delete"
                        color="secondary"
                        onClick={() => {
                          setValue("base64", "");
                          setValue("certificationFile", "");
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                )}
              />
            </Grid>
          )}
        </InputFileContainer>
      </FormSection>
    </React.Fragment>
  );
};

export default TutorForm;
